/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Loading_MediaInputs */



/**
* | output |
* | --- |
* | "Loading media..." |
*
* @param {Work_Order_Import_Status_Loading_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_loading_media = /** @type {((inputs?: Work_Order_Import_Status_Loading_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Loading_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du média...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien werden geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento del contenuto multimediale...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка медиафайлов...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando medios...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载媒体……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando mídia...")
	return /** @type {LocalizedString} */ ("Loading media...")
});